import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Weather from "../../../components/pages/home/c-weather";
import News from "../../../components/pages/home/c-news";
import Partners from "../../../components/pages/home/c-partners";
import Reserve from "../../../components/pages/home/c-reserve";
import Agenda from "../../../components/pages/home/c-agenda";
import BannerCarousel from "../../../components/pages/home/c-bannercarousel";
// import MarqueeText from "../../../components/pages/home/c-marquee-text";
import "../../../assets/css/home.css";

const Accueil = () => {
  return (
    <main role="main" className="mc-fond-ecran">
      <Container fluid className="gx-0">
        {/* <Row className="mt-2">
          <MarqueeText />
        </Row> */}
        <Row>
          <BannerCarousel />
        </Row>
        <Row className="pt-3 ps-4">
          <span className="my-4 mc-rampart fs-1 text-danger">
            À ne pas manquer !
          </span>
        </Row>
        <Row>
          <Agenda />
        </Row>
        <Row className="pt-3 ps-4">
          <span className="mc-rampart fs-1 text-danger">Actualités</span>
        </Row>
        <Row>
          <News />
          <Reserve />
          <Weather />
        </Row>
        <Row className="py-3 px-4">
          <span className="mc-partners mc-rampart fs-1">Nos partenaires</span>
        </Row>
        <Row className="pt-3">
          <Partners />
        </Row>
      </Container>
    </main>
  );
};

export default Accueil;
